import {
  ButtonType,
  ButtonWidget,
  DialogFooterButtonsWidget,
  DialogProps,
  DialogWidget,
  InlineAlertType,
  InlineAlertWidget,
} from '@tableau/widgets';
import * as clipboard from 'clipboard-polyfill';
import React from 'react';

import {ToasterService, ToastType} from '~commonInfra/services/ToasterService';
import { ContentActionNotification } from '~src/commonInfra/contentActions/ContentActionNotification';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';

import {Messages} from '../../codegen/Localize';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { PersonalAccessToken } from '../models/PersonalAccessToken';
import {RevokePersonalAccessTokenRequest} from '../serverApi/requests/personalAccess/RevokePersonalAccessTokenRequest';
import {
  buttonStyle,
  dialogTextStyle, tokenSecretTextWidgetStyle, valueStyle,
} from '../styles/CreatePersonalAccessTokenDialogStyle';


export type CreatePersonalAccessTokenDialogProps = {
  token: PersonalAccessToken;
  dismiss: (reason?: any) => void;
};

export function discardToken(props: CreatePersonalAccessTokenDialogProps) {
  WebHttpClient.sendRequest(new RevokePersonalAccessTokenRequest({
    refreshToken : props.token.tokenSecret
  })).then(() => props.dismiss());
  ContentActionNotification.displaySuccessToast(
    Messages.personalAccessTokenDeleteDeviceSuccess({
      NAME: L10n.elideIfLong(props.token.tokenName)
    }));
}

export function copyToClipboard(props: CreatePersonalAccessTokenDialogProps) {
  clipboard.writeText(props.token.tokenSecret);
  ToasterService.instance.pop({ type: ToastType.Info, text: Messages.personalAccessTokensTokenCopied() });
}

export function GetFooterContent(props: CreatePersonalAccessTokenDialogProps) {
  return (
    <>
    <DialogFooterButtonsWidget
      buttons={[
        {
          handleClick: () => {
            discardToken(props);
          },
          buttonType: ButtonType.Outline,
          children: Messages.personalAccessTokenDiscard(),
          testId: 'footer-discard',
        },
        {
          handleClick: () => {
            props.dismiss();
          },
          buttonType: ButtonType.Primary,
          children: Messages.personalAccessTokenDone(),
          testId: 'footer-done',
        }
      ]}
      testId='footer'
    />
    </>
  );
}

export function PatSecretWarning(errorMsg: string) {
  return <div>
      <InlineAlertWidget
          children={errorMsg}
          type={InlineAlertType.Warning}
          testId={`pat-secret-warning`}
      />
  </div>;
}

export function LabelAndValueWidget(label: string, value: string) {
  return(
    <>
      <div>{label}</div>
      <div className={valueStyle}>{value}</div>
    </>
  );
}

export function GetDialogWidget(dialogProps: DialogProps, token: PersonalAccessToken, props: CreatePersonalAccessTokenDialogProps) {
  return (
    <DialogWidget {...dialogProps} dialogWidth={TabDialogWidth.width600px}>
      {PatSecretWarning(Messages.personalAccessTokenOneTimeWarning())}
      <div className={dialogTextStyle}>{LabelAndValueWidget(Messages.personalAccessTokenExpirationDate(), token.tokenExpiration)}</div>
      <div className={dialogTextStyle}>{LabelAndValueWidget(Messages.personalAccessTokenName(), token.tokenName)}</div>
      <div className={tokenSecretTextWidgetStyle}>
        <div className={dialogTextStyle}>{LabelAndValueWidget(Messages.personalAccessTokenSecret(), token.tokenSecret)}</div>
        <div className={buttonStyle}>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            testId='pat-secret-copy-to-clipboard'
            onClick={() => copyToClipboard(props)}
            children={Messages.personalAccessTokenCopy()}
            />
        </div>
      </div>
    </DialogWidget>
  );
}
